import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class VigenciaPorteService extends Service {
  async consultarVigencias (codPorte) {
    let vigencias = [];
    let brancoAcoes = '';
    let tipoBotaoCancelamento = '';
    let result = await this.getVigenciaPorteApi().consultarVigencias(codPorte);
    result.map(res => {
      const { codVigencia, codPorteAnestesico, valPorte, dtaInicio, dtaFim, dtaCancelamento, txtMotivoCancelamento, codUsuarioCancelamento, nomeUsuarioCancelamento } = res;
      if (dtaCancelamento !== null) {
        tipoBotaoCancelamento = 'DESFAZER';
      } else {
        tipoBotaoCancelamento = 'CANCELAR';
      }
      vigencias.push(Object.values({ codVigencia, codPorteAnestesico, valPorte, dtaInicio, dtaFim, dtaCancelamento, txtMotivoCancelamento, codUsuarioCancelamento, nomeUsuarioCancelamento, tipoBotaoCancelamento, brancoAcoes }));
    });
    return vigencias || [];
  }
  async consultarPortes () {
    let portes = await this.getVigenciaPorteApi().consultarPortes();
    return portes || [];
  }
  async incluirVigencia (vigencia) {
    let result = await this.getVigenciaPorteApi().incluirVigencia(vigencia);
    return result;
  }
  async excluirVigencia (codVigencia) {
    let result = await this.getVigenciaPorteApi().excluirVigencia(codVigencia);
    return result;
  }
  async alterarVigencia (vigencia) {
    let result = await this.getVigenciaPorteApi().alterarVigencia(vigencia);
    return result;
  }
  async validarVigencia (vigencia, indInclusao) {
    const result = await this.getVigenciaPorteApi().validarVigencia(vigencia, indInclusao);
    return result;
  }
  async cancelarVigencia (codVigencia, motivoCancelamento) {
    const result = await this.getVigenciaPorteApi().cancelarVigencia(codVigencia, motivoCancelamento);
    return result;
  }
  async desfazerCancelamentoVigencia (codVigencia) {
    const result = await this.getVigenciaPorteApi().desfazerCancelamentoVigencia(codVigencia);
    return result;
  }
  async consultarValorPorte (codPorteAnestesico, dataRealizacao) {
    let portes = await this.getVigenciaPorteApi().consultarValorPorte(codPorteAnestesico, dataRealizacao);
    return portes || [];
  }
}
export default VigenciaPorteService;
